const FilterOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.8435 5.53804C18.9951 5.3359 19.0195 5.06545 18.9065 4.83946C18.7935 4.61346 18.5625 4.4707 18.3098 4.4707H6.28965C6.03697 4.4707 5.80599 4.61346 5.69299 4.83946C5.57999 5.06545 5.60438 5.3359 5.75598 5.53804L10.9646 12.5364V19.1465C10.9646 19.3992 11.1073 19.6302 11.3333 19.7432C11.5593 19.8562 11.8298 19.8318 12.0319 19.6802L13.3661 18.6796C13.534 18.5536 13.6329 18.3559 13.6329 18.1459V12.5357L18.8435 5.53804Z"
      stroke="currentColor"
    />
  </svg>
)

export default FilterOutline
